import {makeStyles, Theme} from '@material-ui/core/styles'

export const useTimePickerStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    minHeight: '200px'
  },
  wheelPickerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
    justifyContent: 'center'
  }
}))

export const useWheelColumnStyles = makeStyles((theme: Theme) => ({
  columnContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    width: '60px',
    height: '200px'
  },
  scrollContainer: {
    position: 'relative',
    height: '200px',
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  itemsList: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    transition: 'transform 0.3s ease-out',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },
  item: {
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: '16px',
    fontFamily: 'Inter',
    color: '#52667a',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
  },
  selectedItem: {
    color: '#1976d2',
    fontWeight: 600,
    backgroundColor: 'rgba(25, 118, 210, 0.08)'
  },
  separator: {
    fontSize: '18px',
    fontWeight: 500,
    color: '#52667a',
    margin: `0 ${theme.spacing(1)}px`,
    alignSelf: 'center'
  },
  selectionOverlay: {
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    height: '40px',
    transform: 'translateY(-50%)',
    border: '2px solid #1976d2',
    borderRadius: '4px',
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
    pointerEvents: 'none',
    zIndex: 1
  }
}))
